import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import { atom, useAtom, useSetAtom } from 'jotai';
import { lensMapping } from '../helpers/LensMapping';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';

const lenses = Object.keys(lensMapping);
export const lensAtom = atom(lenses[0]);
export const darkModeAtom = atom(true);


function NavBar() {
    const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);
    const selectLens = useSetAtom(lensAtom);
    const [darkMode, setDarkMode] = useAtom(darkModeAtom);

    const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElNav(event.currentTarget);
    };

    const handleCloseNavMenu = (lens: any) => {
        setAnchorElNav(null);
        lens && selectLens(lens);
    };

    return (
        <AppBar position="static" elevation={0.75}>
            <Container maxWidth={false}>
                <Toolbar disableGutters>
                    <Typography
                        variant="h6"
                        noWrap
                        component="a"
                        sx={{
                            mr: 2,
                            display: { xs: 'none', md: 'flex' },
                            fontFamily: 'monospace',
                            fontWeight: 700,
                            letterSpacing: '.1rem',
                            color: 'inherit',
                            textDecoration: 'none',
                        }}
                    >
                        Khang Nguyen
                    </Typography>

                    <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                        <IconButton
                            size="large"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleOpenNavMenu}
                            color="inherit"
                        >
                            <MenuIcon />
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorElNav}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            open={Boolean(anchorElNav)}
                            onClose={()=>handleCloseNavMenu(null)}
                            sx={{ display: { xs: 'block', md: 'none' } }}
                        >
                            {lenses.map((lens) => (
                                <MenuItem key={lens} onClick={()=>handleCloseNavMenu(lens)}>
                                    <Typography sx={{ textAlign: 'center' }}>{lens.toUpperCase()}</Typography>
                                </MenuItem>
                            ))}
                        </Menu>
                    </Box>
                    <Typography
                        variant="h5"
                        noWrap
                        component="a"
                        sx={{
                            mr: 2,
                            display: { xs: 'flex', md: 'none' },
                            flexGrow: 1,
                            fontFamily: 'monospace',
                            fontWeight: 700,
                            letterSpacing: '.1rem',
                            color: 'inherit',
                            textDecoration: 'none',
                        }}
                    >
                        Khang Nguyen
                    </Typography>
                    <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' }, alignItems:'center', justifyContent:'center', maxWidth:'xl'}}>
                        {lenses.map((lens) => (
                            <Button
                                key={lens}
                                onClick={()=>handleCloseNavMenu(lens)}
                                sx={{ my: 2, color: 'inherit', display: 'block'}}
                            >
                                {lens}
                            </Button>
                        ))}
                    </Box>
                    <IconButton>
                    {darkMode ? <LightModeIcon onClick={()=>setDarkMode(false)}/>:
                    <DarkModeIcon onClick={()=>setDarkMode(true)}/>}
                    </IconButton>
                </Toolbar>
            </Container>
        </AppBar>
    );
}
export default NavBar;